<template>
    <div v-if="canAccess" :class="'bizcomp-bank-manager bizcomp ' + className">
        <div class="bank-manager-head">
            <el-menu
                :default-active="activeIndex"
                class="el-menu-demo"
                mode="horizontal"
                background-color="#ffffff"
                text-color="#666666"
                active-text-color="var(--color-primary)"
                v-on:select="handleSelect"
            >
                <el-menu-item index="1">
                    <div :class="'height-63 ' + (activeIndex === '1' ? 'border-4' : '')">
                        银行卡管理
                    </div>
                </el-menu-item>
                <el-menu-item v-if="changeCardDisplay" index="2">
                    <div :class="'height-63 ' + (activeIndex === '2' ? 'border-4' : '')">
                        换卡记录
                    </div>
                </el-menu-item>
                <el-menu-item v-if="$util.getBusinessModule('0A3')" index="3">
                    <div :class="'height-63 ' + (activeIndex === '3' ? 'border-4' : '')">
                        银行卡签约/解约
                    </div>
                </el-menu-item>
                <el-menu-item v-if="$cache.getUser().certificatetype == '00'" index="4">
                    <div :class="'height-63 ' + (activeIndex === '4' ? 'border-4' : '')">
                        身份证号位数转换
                    </div>
                </el-menu-item>
            </el-menu>
        </div>
        <div class="bottom-info">
            <bank-dc v-if="activeIndex === '1'" :embedded="true" />
            <change-card-list v-else-if="activeIndex === '2'" :embedded="true" />
            <sign-and-unsign v-else-if="activeIndex === '3'" :embedded="true" />
            <id-number-tran v-else-if="activeIndex === '4'" :embedded="true" />
        </div>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import BankDc from "@/bizcomponents/acctManager/bankDc.vue";
import ChangeCardList from "@/bizcomponents/bank/changeCardList.vue";
import SignAndUnsign from "@/bizcomponents/bank/signAndUnsign.vue";
import IdNumberTran from "@/bizcomponents/acctManager/idNumberTran.vue";

export default {
    name: "BankManager",
    components: {
        BankDc,
        ChangeCardList,
        SignAndUnsign,
        IdNumberTran
    },
    mixins: [mixin],
    data() {
        const accountInfo = this.$cache.getParamValue("account_info");
        return {
            canAccess: true,
            activeIndex: "1",
            changeCardDisplay: !(accountInfo && accountInfo.showchangebankcard == false)
        };
    },
    watch: {
        "$route.query.activeIndex": {
            immediate: true,
            handler(val) {
                if (!this.canAccess) {
                    return;
                }
                const nextIndex = val || "1";
                const normalizedIndex = this.isTabAvailable(nextIndex) ? nextIndex : "1";
                this.activeIndex = normalizedIndex;
                if (nextIndex !== normalizedIndex) {
                    this.$router
                        .replace({
                            name: "bankmanager",
                            query: normalizedIndex === "1" ? {} : { activeIndex: normalizedIndex }
                        })
                        .catch(() => {});
                }
            }
        }
    },
    created() {
        if (!this.hasBankManagerAccess()) {
            this.canAccess = false;
            this.$router.replace({ name: "acctManager" }).catch(() => {});
        }
    },
    methods: {
        hasBankManagerAccess() {
            return this.$util.getConfig().hideFunc && !this.$util.isWebQueryMode();
        },
        isTabAvailable(index) {
            if (index === "1") {
                return true;
            }
            if (index === "2") {
                return this.changeCardDisplay;
            }
            if (index === "3") {
                return this.$util.getBusinessModule("0A3");
            }
            if (index === "4") {
                return this.$cache.getUser().certificatetype == "00";
            }
            return false;
        },
        handleSelect(key) {
            if (!this.isTabAvailable(key)) {
                return;
            }
            this.activeIndex = key;
            this.$router
                .replace({
                    name: "bankmanager",
                    query: key === "1" ? {} : { activeIndex: key }
                })
                .catch(() => {});
        }
    }
};
</script>

<style lang="scss" scoped>
.bizcomp-bank-manager {
    .bank-manager-head {
        height: 70px;
        padding-bottom: 7px;
        border: 1px solid #f1f1f1;
        box-sizing: border-box;
        width: 1198px;
    }

    :deep(.el-menu) {
        border: none;
    }

    .el-menu-item {
        padding: 0 28px;
        width: auto;
        min-width: 120px;
        text-align: center;
        height: 59px;
        line-height: 59px;
        font-size: 20px;
        color: #666;
        border: none;
        background-color: #ffffff !important;
        white-space: nowrap;
    }

    .el-menu-item:hover {
        color: var(--color-primary) !important;
        background-color: #ffffff !important;
    }

    :deep(.is-active) {
        color: var(--color-primary);
        font-weight: 500;
    }

    .border-4 {
        border-bottom: 4px solid var(--color-primary);
    }

    .height-63 {
        width: auto;
        min-width: 0;
        height: 59px;
        margin: auto;
        white-space: nowrap;
    }

    .bottom-info {
        padding: 21px 16px 20px 20px;
        width: 1198px;
        box-sizing: border-box;
    }
}
</style>
